import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { ActionButton } from '../ActionButton/ActionButton/component.js';
import { DeleteActionButton } from '../ActionButton/DeleteActionButton/component.js';
import { EditActionButton } from '../ActionButton/EditActionButton/component.js';
var _excluded = ["buttons", "keyField", "maxLabels", "row", "showLabels"];

var ActionButtons = function ActionButtons(_ref) {
  var _ref$buttons = _ref.buttons,
      buttons = _ref$buttons === void 0 ? [] : _ref$buttons,
      keyField = _ref.keyField,
      _ref$maxLabels = _ref.maxLabels,
      maxLabels = _ref$maxLabels === void 0 ? 1 : _ref$maxLabels,
      _ref$row = _ref.row,
      row = _ref$row === void 0 ? {} : _ref$row,
      showLabels = _ref.showLabels,
      rest = _objectWithoutProperties(_ref, _excluded);

  var renderButtons = function renderButtons() {
    var visibleButtons = buttons.filter(function (button) {
      switch (button.type) {
        case 'edit':
          return row.can_edit !== false;

        case 'delete':
          return row.can_delete !== false;

        default:
          return true;
      }
    });
    var showLabel = showLabels || visibleButtons.length <= maxLabels;
    return visibleButtons.map(function (button, index) {
      var ButtonComponent = getButtonComponent(button.type);
      return /*#__PURE__*/React.createElement(ButtonComponent, _extends({}, rest, button, {
        key: index,
        keyField: keyField,
        row: row,
        showLabel: showLabel
      }));
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "action-buttons"
  }, renderButtons());
};

ActionButtons.displayName = "ActionButtons";

var getButtonComponent = function getButtonComponent(type) {
  switch (type) {
    case 'edit':
      return EditActionButton;

    case 'delete':
      return DeleteActionButton;

    default:
      return ActionButton;
  }
};

export { ActionButtons };